<template>
  <div class="">
    <div class="is-pulled-left">
      <p class="chart-title">
        <slot name="logo" />
        {{ title }}
        <slot name="tooltip" />
      </p>
    </div>
    <div class="is-pulled-right has-text-right">
      <div class="total-block">
        <p
          v-if="totalFormat == 'currency'"
          class="total has-text-weight-bold"
        >
          {{ $n(total, 'currency') }}
        </p>
        <p
          v-else
          class="total has-text-weight-bold"
        >
          {{ total | numberFormat(totalFormat) }}
        </p>
        <div
          class="increase-rate"
          :class="increaseRateUpOrDown"
        >
          <i
            class=""
            :class="`icon-caret-${increaseRateUpOrDown}`"
            aria-hidden="true"
          />
          <span>{{ increaseRate | numberFormat('0.0%') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'total', 'prevTotal', 'totalFormat'],
  computed: {
    increaseRate () {
      if (!this.prevTotal) return 0
      return this.prevTotal ? ((this.total - this.prevTotal) / this.prevTotal) : 0
    },
    increaseRateUpOrDown () {
      return this.increaseRate >= 0 ? 'up' : 'down'
    }
  }
}
</script>

<style scoped lang="scss">
.chart-title {
  font-size: 16px;
  font-family: 'Noto Sans', sans-serif;
}

.total-block {
  display: block;
  font-family: 'Roboto', sans-serif;

  .total {
    font-size: 44px;
    line-height: 50px;
  }
}

.increase-rate {
  font-weight: 500;

  i {
    font-size: 10px;
  }

  span {
    font-size: 14px;
  }
}

.increase-rate.up {
  color: $primary;
}

.increase-rate.down {
  color: #e23e57;
}
</style>
